import React, { useMemo } from 'react';
import { useSubscriberDomainParams } from 'global/hooks/useSubscriberDomainParams';
import EmploymentDetailsPageStore, {
  EmploymentDetailsPageStoreContext,
} from 'store/pages/subscriber/imq/employment-details/pageStore';
import PageContent from 'components/subscriber/imq/employment-details';

const EmploymentDetailsPage: React.FC = () => {
  const { groupId, subscriberId, entityId } = useSubscriberDomainParams();

  const pageStore = useMemo(
    () => new EmploymentDetailsPageStore({ groupId, subscriberId, entityId }),
    [groupId, subscriberId, entityId],
  );

  return (
    <EmploymentDetailsPageStoreContext.Provider value={pageStore}>
      <PageContent />
    </EmploymentDetailsPageStoreContext.Provider>
  );
};

export default EmploymentDetailsPage;
